import { render } from "./Icd.vue?vue&type=template&id=585cb6a6&lang=true"
import script from "./Icd.vue?vue&type=script&lang=js"
export * from "./Icd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__